import React from 'react';
import Header from './Header';
import PlanCards from './PlanCards';
import Hero from './Hero';
import WhyChooseUs from './WhyChooseUs';
import QuiNousSommes from './QuiNousSommes';
import BeforeAfterGallery from './BeforeAfterGallery';
import Testimonials from './Testimonials';
import Contact from './Contact';
import Footer from './Footer';
import { Toaster } from './ui/sonner';

const LavagePage = ({ onNavigate }) => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <PlanCards onNavigateToScellant={() => onNavigate && onNavigate('scellant')} />
        <WhyChooseUs />
        <QuiNousSommes theme="light" />
        <BeforeAfterGallery />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </>
  );
};

export default LavagePage;
